<template>
	<ul class="pagination style-rounded">
		<li class="page-item" :class="{ disabled: currentPage === 1 }">
			<a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
				&laquo;
			</a>
		</li>

		<li v-for="page in pages" :key="page" class="page-item" :class="{ active: page === currentPage }">
			<a class="page-link" href="#" @click.prevent="changePage(page)">
				{{ page }}
			</a>
		</li>

		<li class="page-item" :class="{ disabled: currentPage === totalPages }">
			<a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
				&raquo;
			</a>
		</li>
	</ul>
</template>

<script>
	export default {
  props: {
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    maxVisibleButtons: {
      type: Number,
      default: 3
    },
  },
  data() {
    return {
    };
  },
  computed: {
    // 根据样式类型返回对应的CSS类
    styleClass() {
      if (this.styleType === 'standard') return '';
      return `style-${this.styleType}`;
    },

    // 计算要显示的页码数组
    pages() {
      const range = [];
      const half = Math.floor(this.maxVisibleButtons / 2);
      let start = this.currentPage - half;
      let end = this.currentPage + half;

      if (start < 1) {
        start = 1;
        end = this.maxVisibleButtons;
      }

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(1, end - this.maxVisibleButtons + 1);
      }

      for (let i = start; i <= end; i++) {
        range.push(i);
      }

      return range;
    }
  },
  components: {
  },
  mounted() {

  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.$emit('pagechanged', page);
    }
  },

  watch: {
  }
};
</script>

<style scoped></style>